__webpack_require__.p = "/admin-details-dropdown/onboarding/";